





















module.exports = {
  "contents":   {
    "contents": () => import("../../../components/contents/contents.js")
  },
  "election-results":   {
    "elected-connetables": () => import("../../../components/election-results/elected-connetables.js"),
    "elected-deputies-slider": () => import("../../../components/election-results/elected-deputies-slider.js"),
    "elected-deputies": () => import("../../../components/election-results/elected-deputies.js"),
    "election-results": () => import("../../../components/election-results/election-results.js"),
    "last-modified": () => import("../../../components/election-results/last-modified.js")
  },
  "countdown":   {
    "countdown": () => import("../../../components/countdown/countdown.js")
  },
  "global":   {
    "site-search": () => import("../../../components/global/site-search.js")
  },
  "infinite-list":   {
    "_original_infinite-list": () => import("../../../components/infinite-list/_original_infinite-list.js"),
    "infinite-list": () => import("../../../components/infinite-list/infinite-list.js")
  },
  "main-infinite-list":   {
    "main-infinite-list": () => import("../../../components/main-infinite-list/main-infinite-list.js")
  },
  "table":   {
    "table": () => import("../../../components/table/table.js")
  },
  "header":   {
    "nav-primary":     {
      "nav-primary": () => import("../../../components/header/nav-primary/nav-primary.js")
    }
  }
}